import { makeImmutable } from "../../core/makeImmutable";
import { PositiveQuantity } from "../PositiveQuantity";
/**
 * Products or modifiers and its amount to be packed in a container.
 *
 * For example "kebab x2".
 */
export class PackingItem {
    constructor(params) {
        this.subject = params.subject;
        this.quantity = params.quantity;
        makeImmutable(this);
    }
    withQuantityValue(quantityValue) {
        return new PackingItem({
            subject: this.subject,
            quantity: new PositiveQuantity(quantityValue),
        });
    }
    get productVolume() {
        return this.subject.volume;
    }
    get totalVolume() {
        return this.subject.volume.multiply(this.quantity);
    }
    splitToFit(volume) {
        const quotientQuantity = volume.div(this.productVolume).floor().valueOf();
        const quotient = quotientQuantity > 0 ? this.withQuantityValue(quotientQuantity) : null;
        const remainderQuantity = this.quantity.value - quotientQuantity;
        const remainder = remainderQuantity > 0 ? this.withQuantityValue(remainderQuantity) : null;
        return { quotient, remainder };
    }
    merge(other) {
        const a = this.subject;
        const b = other.subject;
        // NOTICE TypeScript is not smart enough to know a.id.eq(b.id) when a.type === b.type
        const c1 = a.type === "ModifierItem" && b.type === "ModifierItem" && a.id.eq(b.id);
        const c2 = a.type === "ProductInstance" &&
            b.type === "ProductInstance" &&
            a.id.eq(b.id);
        if ((c1 || c2) && a.volume.eq(b.volume)) {
            return new PackingItem({
                subject: a,
                quantity: this.quantity.add(other.quantity),
            });
        }
        throw new Error("Unable to merge completely different PackingItems");
    }
    /**
     * Multiply by a Quantity
     */
    multiply(quantity) {
        return new PackingItem({
            subject: this.subject,
            quantity: this.quantity.mul(quantity),
        });
    }
    get id() {
        return this.subject.id;
    }
    get checkoutData() {
        const { subject } = this;
        switch (subject.type) {
            case "ProductInstance":
                return {
                    tag: "ProductId",
                    contents: [...subject.productTypeIds].map((productTypeId) => productTypeId.value),
                };
            case "ModifierItem":
                return {
                    tag: "ModifierItemId",
                    contents: [subject.modifierTypeId.value, subject.id.value],
                };
        }
    }
}
